
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Edit, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Company } from '@/lib/types';

interface CompanyDetailsHeaderProps {
  company: Company;
  isAdmin: boolean;
  isActiveCompany: boolean;
  onDelete: () => void;
}

const CompanyDetailsHeader = ({ 
  company, 
  isAdmin, 
  isActiveCompany, 
  onDelete 
}: CompanyDetailsHeaderProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 mb-4 sm:mb-6">
      <div className="flex items-center gap-2 flex-wrap flex-1 min-w-0">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => navigate('/companies')} 
          className="h-8 px-2 sm:h-9 sm:px-3 flex-shrink-0"
        >
          <ArrowLeft className="h-4 w-4 sm:mr-2" />
          <span className="hidden sm:inline">Back</span>
        </Button>
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold truncate">{company.name}</h1>
        {isActiveCompany && (
          <Badge variant="secondary" className="flex-shrink-0">Active</Badge>
        )}
      </div>
      <div className="flex gap-2 flex-wrap sm:flex-nowrap flex-shrink-0">
        {isAdmin && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={() => navigate(`/companies/${company.id}/edit`)}
            className="h-8 px-2 sm:h-9 sm:px-3"
          >
            <Edit className="h-3.5 w-3.5 sm:h-4 sm:w-4 sm:mr-2" />
            <span className="hidden sm:inline">Edit</span>
          </Button>
        )}
        {isAdmin && (
          <Button 
            variant="outline" 
            size="sm" 
            onClick={onDelete}
            className="h-8 px-2 sm:h-9 sm:px-3"
          >
            <Trash2 className="h-3.5 w-3.5 sm:h-4 sm:w-4 sm:mr-2" />
            <span className="hidden sm:inline">Delete</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default CompanyDetailsHeader;
